import AddressCapture from '@/components/generic/AddressCapture'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import PropertyDisclosureControl from '@/components/generic/customer/PropertyDisclosureControl'
import RegulationBControl from '@/components/generic/customer/RegulationBControl'
import TermsControl from '@/components/generic/customer/TermsControl'
import ValidateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import WorkhistoryCapture from '@/components/generic/WorkHistoryCapture'
import customerSelector from '@/components/generic/CustomerSelector'

import { mapActions, createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

var mixin = {
  components: {
    'address-capture': AddressCapture,
    'error-display-component': ErrorDisplayComponent,
    'property-disclosure-control': PropertyDisclosureControl,
    'regulation-b-control': RegulationBControl,
    'terms-control': TermsControl,
    'work-history-capture': WorkhistoryCapture,
    'customer-selector': customerSelector
  },
  mixins: [ValidateBeforeSubmitMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isMember: document.cookie.indexOf('LIM=ONE') > -1,
      isLoading: false,
      addresses: [],
      spouseAddresses: [],
      workHistory: [],
      spouseWorkHistory: [],
      selectedMaritalStatus: null,
      selectedEmploymentStatus: null,
      selectedSpouseEmploymentStatus: null,
      selectedRelationshipStatus: null,
      selectedCoCustomer: null,
      currentStep: 0,
      termsVisible: false,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      preventClick: false,
      loadingBaseData: false,
      residenceMonthsValid: true,
      spouseResidenceMonthsValid: true,
      residenceValidated: false,
      spouseResidenceValidated: false,
      residenceError: '',
      spouseResidenceError: '',
      workHistoryMonthsValid: true,
      spouseWorkHistoryMonthsValid: true,
      workHistoryValidated: false,
      spouseWorkHistoryValidated: false,
      // homePhoneValidated: false,
      // homePhoneError: '',
      workHistoryError: '',
      spouseWorkHistoryError: '',
      dealerId: 0,
      hasSaved: false,
      defaultDate: new Date('01/01/1970'),
      datePickerOptions: {
        disabledDate (date) {
          return date.getFullYear() > new Date().getFullYear() - 18
        },
        defaultView: 'year'
      },
      bulmaSteps: undefined
    }
  },
  computed: {
    ...mapUserGetters(['currentUser']),
    ...mapConfigGetters(['definedTypes']),
    isPrimaryPhoneAreaCodeValid: function () {
      if (this.currentCustomer) {
        const home = this.currentCustomer.home ? this.currentCustomer.home : ''
        const homeAreaCode = home.slice(3, 6)
        if (homeAreaCode === '800' || homeAreaCode === '866' || homeAreaCode === '877' || homeAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Home Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isPrimaryMobilePhoneAreaCodeValid: function () {
      if (this.currentCustomer) {
        const mobile = this.currentCustomer.mobile ? this.currentCustomer.mobile : ''
        const mobileAreaCode = mobile.slice(3, 6)
        if (mobileAreaCode === '800' || mobileAreaCode === '866' || mobileAreaCode === '877' || mobileAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Mobile Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isCoAppPhoneAreaCodeValid: function () {
      if (this.currentCustomer && this.currentCustomer.coApplicant) {
        const home = this.currentCustomer.coApplicant.home ? this.currentCustomer.coApplicant.home : ''
        const homeAreaCode = home.slice(3, 6)
        if (homeAreaCode === '800' || homeAreaCode === '866' || homeAreaCode === '877' || homeAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Co-Applicant Home Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isCoAppMobilePhoneAreaCodeValid: function () {
      if (this.currentCustomer && this.currentCustomer.coApplicant) {
        const mobile = this.currentCustomer.coApplicant.mobile ? this.currentCustomer.coApplicant.mobile : ''
        const mobileAreaCode = mobile.slice(3, 6)
        if (mobileAreaCode === '800' || mobileAreaCode === '866' || mobileAreaCode === '877' || mobileAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Co-Applicant Mobile Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpousePhoneAreaCodeValid: function () {
      if (this.currentCustomer && this.currentCustomer.spouse) {
        const home = this.currentCustomer.spouse.home ? this.currentCustomer.spouse.home : ''
        const homeAreaCode = home.slice(3, 6)
        if (homeAreaCode === '800' || homeAreaCode === '866' || homeAreaCode === '877' || homeAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Spouse Home Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpouseMobilePhoneAreaCodeValid: function () {
      if (this.currentCustomer && this.currentCustomer.spouse) {
        const mobile = this.currentCustomer.spouse.mobile ? this.currentCustomer.spouse.mobile : ''
        const mobileAreaCode = mobile.slice(3, 6)
        if (mobileAreaCode === '800' || mobileAreaCode === '866' || mobileAreaCode === '877' || mobileAreaCode === '555') {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'Invalid Spouse Mobile Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
          }
        }
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isPrimaryAddressValid: function () {
      const numberOfPrimaryAddresses = this.addresses.filter((x) => x.isPrimary).length
      if (numberOfPrimaryAddresses === 1) {
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      if (numberOfPrimaryAddresses === 0) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'Please select your primary addresses below.'
        }
      } else if (numberOfPrimaryAddresses > 1) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'You can only have one your primary address.'
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpousePrimaryAddressValid: function () {
      const numberOfPrimaryAddresses = this.spouseAddresses.filter((x) => x.isPrimary).length
      if (numberOfPrimaryAddresses === 1) {
        return {
          valid: true,
          errorCode: 1,
          errorMessage: ''
        }
      }
      if (numberOfPrimaryAddresses === 0) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'Please select your spouse\'s primary addresses below.'
        }
      } else if (numberOfPrimaryAddresses > 1) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'Your spouse can only have one primary address.'
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isResidenceMonthsValid: function () {
      const months = this.totalResidenceMonths
      if (months < 36) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'You are required to provide at least 3 years of residence history.'
        }
      } else if (months > 1199) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'The total amount of months lived at a specific address cannot exceed 1199. The years and months fields are combined to calculate the total months of occupation at a specific address.'
        }
      } else if (months > this.calculateAgeInMonths) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'The total amount of months lived at a specific address cannot exceed age.'
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isWorkHistoryMonthsValid: function () {
      if (this.selectedEmploymentStatus && (this.selectedEmploymentStatus.id === 0 || this.selectedEmploymentStatus.id === 3 || this.selectedEmploymentStatus.id === 6)) {
        const months = this.totalWorkHistoryMonths
        if (months < 24) {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'You are required to provide at least 2 years of employment history.'
          }
        } else if (months > 1199) {
          return {
            valid: false,
            errorCode: 0,
            errorMessage: 'The total amount of months employed at a specific employer cannot exceed 1199. The years and months fields are combined to calculate the total months of employment at a specific employer.'
          }
        }
        // if (this.workHistory && this.workHistory.length > 0) {
        //   for (var i = 0; i < this.workHistory.length; i++) {
        //     if (this.workHistory[i].employerOffice === this.currentCustomer.mobile) {
        //       return {
        //         valid: false,
        //         errorCode: 0,
        //         errorMessage: 'Employer phone cannot be the same as mobile.'
        //       }
        //     }
        //   }
        // }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isWorkHistoryEmployerValid: function () {
      if (this.selectedEmploymentStatus && (this.selectedEmploymentStatus.id === 0 || this.selectedEmploymentStatus.id === 3)) {
        if (this.workHistory && this.workHistory.length > 0) {
          for (var i = 0; i < this.workHistory.length; i++) {
            if (this.workHistory[i].employer === this.workHistory[i].address1) {
              return {
                valid: false,
                errorCode: 0,
                errorMessage: 'Invalid Employer Name. Please check each of your provided Employment History records.'
              }
            }
          }
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isWorkHistoryPhoneAreaCodeValid: function () {
      if (this.selectedEmploymentStatus && (this.selectedEmploymentStatus.id === 0 || this.selectedEmploymentStatus.id === 3 || this.selectedEmploymentStatus.id === 5 || this.selectedEmploymentStatus.id === 6 || this.selectedEmploymentStatus.id === 7)) {
        if (this.workHistory && this.workHistory.length > 0) {
          for (var i = 0; i < this.workHistory.length; i++) {
            const office = this.workHistory[i].employerOffice
            const officeAreaCode = office.slice(3, 6)
            if (officeAreaCode === '800' || officeAreaCode === '866' || officeAreaCode === '877' || officeAreaCode === '555') {
              return {
                valid: false,
                errorCode: 0,
                errorMessage: 'Invalid Employer Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
              }
            }
          }
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpouseResidenceMonthsValid: function () {
      const months = this.totalSpouseResidenceMonths
      if (months < 36) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'You are required to provide at least 3 years of residence history.'
        }
      } else if (months > 1199) {
        return {
          valid: false,
          errorCode: 0,
          errorMessage: 'The total amount of months lived at a specific address cannot exceed 1199. The years and months fields are combined to calculate the total months of occupation at a specific address.'
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpouseWorkHistoryMonthsValid: function () {
      if (this.selectedSpouseEmploymentStatus) {
        if (this.selectedSpouseEmploymentStatus.id === 0 || this.selectedSpouseEmploymentStatus.id === 3) {
          const months = this.totalSpouseWorkHistoryMonths
          if (months < 24) {
            return {
              valid: false,
              errorCode: 0,
              errorMessage: 'You are required to provide at least 2 years of employment history.'
            }
          } else if (months > 1199) {
            return {
              valid: false,
              errorCode: 0,
              errorMessage: 'The total amount of months employed at a specific employer cannot exceed 1199. The years and months fields are combined to calculate the total months of employment at a specific employer.'
            }
          }
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpouseWorkHistoryEmployerValid: function () {
      if (this.selectedSpouseEmploymentStatus && (this.selectedSpouseEmploymentStatus.id === 0 || this.selectedSpouseEmploymentStatus.id === 3 || this.selectedSpouseEmploymentStatus.id === 6)) {
        if (this.spouseWorkHistory && this.spouseWorkHistory.length > 0) {
          for (var i = 0; i < this.spouseWorkHistory.length; i++) {
            if (this.spouseWorkHistory[i].employer === this.spouseWorkHistory[i].address1) {
              return {
                valid: false,
                errorCode: 0,
                errorMessage: 'Invalid Spouse Employer Name. Please check each of your provided Spouse Employment History records.'
              }
            }
          }
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    isSpouseWorkHistoryPhoneAreaCodeValid: function () {
      if (this.selectedSpouseEmploymentStatus && (this.selectedSpouseEmploymentStatus.id === 0 || this.selectedSpouseEmploymentStatus.id === 3 || this.selectedSpouseEmploymentStatus.id === 5 || this.selectedSpouseEmploymentStatus.id === 6 || this.selectedSpouseEmploymentStatus.id === 7)) {
        if (this.spouseWorkHistory && this.spouseWorkHistory.length > 0) {
          for (var i = 0; i < this.spouseWorkHistory.length; i++) {
            const office = this.spouseWorkHistory[i].employerOffice
            const officeAreaCode = office.slice(3, 6)
            if (officeAreaCode === '800' || officeAreaCode === '866' || officeAreaCode === '877' || officeAreaCode === '555') {
              return {
                valid: false,
                errorCode: 0,
                errorMessage: 'Invalid Spouse Employer Phone Area Code. Please enter an area code that is not one of the following (800, 866, 877, 555).'
              }
            }
          }
        }
      }
      return {
        valid: true,
        errorCode: 1,
        errorMessage: ''
      }
    },
    // isHomePhoneValid: function () {
    //   if (this.currentCustomer.home && this.currentCustomer.mobile) {
    //     if (this.currentCustomer.home === this.currentCustomer.mobile) {
    //       return {
    //         valid: false,
    //         errorCode: 0,
    //         errorMessage: 'Home phone cannot be the same as mobile.'
    //       }
    //     }
    //   }
    //   return {
    //     valid: true,
    //     errorCode: 1,
    //     errorMessage: ''
    //   }
    // },
    isValidationRequired: function () {
      return true
    },
    thisValidator: function () {
      return (this && this.$validator) ? this.$validator : null
    },
    isCreditTermsAccepted: function () {
      return this.currentCustomer ? this.currentCustomer.isCreditTermsAccepted : false
    },
    isCommunityPropertyDisclosureAccepted: function () {
      return this.currentCustomer ? this.currentCustomer.communityPropertyDisclosure : false
    },
    isRegulationBAccepted: function () {
      return this.currentCustomer ? this.currentCustomer.regulationB : false
    },
    creditApplicationCompleted: function () {
      return this.currentCustomer ? this.currentCustomer.isCreditApplicationComplete : false
    },
    showRemoveAddress: function () {
      return this.checkRemoveButtonVisibility(this.addresses)
    },
    showRemoveSpouseAddress: function () {
      return this.checkRemoveButtonVisibility(this.spouseAddresses)
    },
    showRemoveWorkHistory: function () {
      return this.checkRemoveButtonVisibility(this.workHistory)
    },
    showRemoveSpouseWorkHistory: function () {
      return this.checkRemoveButtonVisibility(this.spouseWorkHistory)
    },
    showWorkStep: function () {
      return this.selectedEmploymentStatus && this.selectedEmploymentStatus.name !== 'Unemployed'
    },
    isMarried: function () {
      return this.selectedMaritalStatus ? this.selectedMaritalStatus.id === 1 : false
    },
    isCopState: function () {
      if (!this.addresses) return false
      if (this.addresses.length === 0) return false
      let primaryAddress = this.addresses.find(x => x.isPrimary)
      if (!primaryAddress) {
        primaryAddress = this.addresses[0]
      }
      return primaryAddress ? primaryAddress.isCopState : false
    },
    spouseInfoRequired: function () {
      return (this.isMarried && this.isCopState) || this.isCoApplicantSpouse
    },
    communityPropertyDisclosureRequired: function () {
      return this.isCopState
    },
    isSpouseEmployed: function () {
      return this.selectedSpouseEmploymentStatus && this.selectedSpouseEmploymentStatus.name !== 'Unemployed'
    },
    isCustomerCoApplicant: function () {
      return this.currentCustomer ? this.currentCustomer.isCoApplicant : false
    },
    coAppInfoStepCount: function () {
      let stepCount = 2

      if (!this.showCoAppStep) {
        stepCount--
      }

      return stepCount
    },
    spouseInfoStepCount: function () {
      let stepCount = 5

      if (!this.showCoAppStep) {
        stepCount--
      }

      if (!this.showWorkStep) {
        stepCount--
      }

      return stepCount
    },
    spouseWorkStepCount: function () {
      let stepCount = 7

      if (!this.showWorkStep) {
        stepCount--
      }

      if (!this.showSpouseStep) {
        stepCount--
      }

      if (!this.showSpouseResidence) {
        stepCount--
      }

      return stepCount
    },
    showCoAppStep: function () {
      return this.hasCoApplicant && !this.isCoApplicantSpouse
    },
    showSpouseStep: function () {
      return this.spouseInfoRequired
    },
    showSpouseResidence: function () {
      return this.spouseInfoRequired
    },
    showSpouseWork: function () {
      return this.spouseInfoRequired && this.isSpouseEmployed
    },
    hasCoApplicant: function () {
      return this.selectedRelationshipStatus && this.selectedRelationshipStatus.id !== 5 && !this.isCustomerCoApplicant
    },
    isCoApplicantSpouse: function () {
      return this.selectedRelationshipStatus && this.selectedRelationshipStatus.id === 0
    },
    evaluateValidToSubmit: function () {
      if (this.communityPropertyDisclosureRequired && this.hasCoApplicant) {
        return this.isCreditTermsAccepted && this.isCommunityPropertyDisclosureAccepted && this.isRegulationBAccepted
      }
      if (this.communityPropertyDisclosureRequired && !this.hasCoApplicant) {
        return this.isCreditTermsAccepted && this.isCommunityPropertyDisclosureAccepted
      }
      if (!this.communityPropertyDisclosureRequired && this.hasCoApplicant) {
        return this.isCreditTermsAccepted && this.isRegulationBAccepted
      }
      return this.isCreditTermsAccepted
    },
    totalResidenceMonths: function () {
      let totalMonths = 0
      if (this.currentCustomer && this.addresses && this.addresses.length > 0) {
        this.addresses.forEach(function (x) {
          var years = parseInt(x.years) || 0
          var months = parseInt(x.months) || 0
          totalMonths += (years * 12) + months
        })
      }
      return totalMonths
    },
    totalSpouseResidenceMonths: function () {
      let totalMonths = 0
      if (this.currentCustomer && this.spouseAddresses && this.spouseAddresses.length > 0) {
        this.spouseAddresses.forEach(function (x) {
          const years = parseInt(x.years) || 0
          const months = parseInt(x.months) || 0
          totalMonths += (years * 12) + months
        })
      }
      return totalMonths
    },
    totalWorkHistoryMonths: function () {
      let totalMonths = 0
      if (this.currentCustomer && this.workHistory && this.workHistory.length > 0) {
        this.workHistory.forEach(function (x) {
          var years = parseInt(x.years) || 0
          var months = parseInt(x.months) || 0
          totalMonths += (years * 12) + months
        })
      }
      return totalMonths
    },
    totalSpouseWorkHistoryMonths: function () {
      let totalMonths = 0
      if (this.currentCustomer && this.spouseWorkHistory && this.spouseWorkHistory.length > 0) {
        this.spouseWorkHistory.forEach(function (x) {
          const years = parseInt(x.years) || 0
          const months = parseInt(x.months) || 0
          totalMonths += (years * 12) + months
        })
      }
      return totalMonths
    },
    workHistoryHeading: function () {
      var employmentHeading = ''
      if (this.selectedEmploymentStatus) {
        switch (this.selectedEmploymentStatus.id) {
          case 0:
          case 3:
            employmentHeading += 'Provide 2 Years of Work History'
            break
          case 1:
          case 2:
          case 4:
            employmentHeading += 'Provide Income Details'
            break
          default:
            employmentHeading = ''
            break
        }
      }
      return employmentHeading
    },
    workHistorySubHeading: function () {
      var employmentSubHeading = ''
      if (this.selectedEmploymentStatus) {
        switch (this.selectedEmploymentStatus.id) {
          case 0:
          case 3:
            employmentSubHeading = 'Most recent first'
            break
          case 1:
          case 2:
          case 4:
            employmentSubHeading = ''
            break
          default:
            employmentSubHeading = ''
            break
        }
      }
      return employmentSubHeading
    },
    spouseWorkHistoryHeading: function () {
      var employmentHeading = ''
      if (this.selectedSpouseEmploymentStatus) {
        switch (this.selectedSpouseEmploymentStatus.id) {
          case 0:
          case 3:
            employmentHeading += 'Spouse: Provide 2 Years of Work History'
            break
          case 1:
          case 2:
          case 4:
            employmentHeading += 'Spouse: Provide Income Details'
            break
          default:
            employmentHeading = ''
            break
        }
      }
      return employmentHeading
    },
    spouseWorkHistorySubHeading: function () {
      var employmentSubHeading = ''
      if (this.selectedSpouseEmploymentStatus) {
        switch (this.selectedSpouseEmploymentStatus.id) {
          case 0:
          case 3:
            employmentSubHeading = 'Most recent first'
            break
          case 1:
          case 2:
          case 4:
            employmentSubHeading = ''
            break
          default:
            employmentSubHeading = ''
            break
        }
      }
      return employmentSubHeading
    },
    currentScope: function () {
      return this.availableScopes[this.currentStep]
    },
    calculateAge: function () {
      if (!this.currentCustomer) return 0
      if (!this.currentCustomer.dateOfBirth) return 0
      const dateOfBirth = new Date(this.currentCustomer.dateOfBirth)
      var diffMs = new Date() - dateOfBirth.getTime()
      var ageDt = new Date(diffMs)
      return Math.abs(ageDt.getUTCFullYear() - 1970)
    },
    calculateAgeInMonths: function () {
      return this.calculateAge * 12
    },
    calculateSpouseAge: function () {
      if (!this.currentCustomer) return 0
      if (!this.currentCustomer.spouse) return 0
      if (!this.currentCustomer.spouse.dateOfBirth) return 0
      const dateOfBirth = new Date(this.currentCustomer.spouse.dateOfBirth)
      var diffMs = new Date() - dateOfBirth.getTime()
      var ageDt = new Date(diffMs)
      return Math.abs(ageDt.getUTCFullYear() - 1970)
    },
    calculateSpouseAgeInMonths: function () {
      return this.calculateSpouseAge * 12
    },
    isUser: function () {
      return this.currentUser !== null && this.currentUser !== undefined && this.currentUser.roles.length > 0
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    visibilityChanged (newValue, oldValue) {
      this.termsVisible = newValue
    },
    checkRemoveButtonVisibility (dataCollection) {
      if (dataCollection.length > 1) {
        return true
      }
      return false
    },
    async validateStep (e) {
      this.preventClick = false
      this.$validator.validate(this.currentScope + '.*').then((result) => {
        if (result === false) {
          if (this.isUser || this.isMember) return
          this.preventClick = true
          this.$goToFirstValidationError(this.$validator.errors.items.filter((x) => x.scope === this.currentScope))
        }
      })
    },
    validateResidenceHistory () {
      this.residenceValidated = true
      const months = this.totalResidenceMonths
      if (months < 36) {
        this.residenceMonthsValid = false
        this.residenceError = 'You are required to provide at least 3 years of residence history.'
        if (this.isUser || this.isMember) return []
        return ['Error occurred']
      } else if (months > 1199) {
        this.residenceMonthsValid = false
        this.residenceError = 'The total amount of months lived at a specific address cannot exceed 1199. The years and months fields are combined to calculate the total months of occupation at a specific address.'
        if (this.isUser || this.isMember) return []
        return ['Error occurred']
      } else if (months > this.calculateAgeInMonths) {
        this.residenceMonthsValid = false
        this.residenceError = 'The total amount of months lived at a specific address cannot exceed age.'
        if (this.isUser || this.isMember) return []
        return ['Error occurred']
      }
      this.residenceMonthsValid = true
      return []
    },
    validateSpouseResidenceHistory () {
      this.spouseResidenceValidated = true
      const months = this.totalSpouseResidenceMonths
      if (months < 36) {
        this.spouseResidenceMonthsValid = false
        this.spouseResidenceError = 'You are required to provide at least 3 years of residence history.'
        if (this.isUser || this.isMember) return []
        return ['Error occurred']
      } else if (months > 1199) {
        this.spouseResidenceMonthsValid = false
        this.spouseResidenceError = 'The total amount of months lived at a specific address cannot exceed 1199. The years and months fields are combined to calculate the total months of occupation at a specific address.'
        if (this.isUser || this.isMember) return []
        return ['Error occurred']
      }
      this.spouseResidenceMonthsValid = true
      return []
    },
    validateWorkHistory () {
      this.workHistoryValidated = true

      if (this.selectedEmploymentStatus.id === 0 || this.selectedEmploymentStatus.id === 3) {
        const months = this.totalWorkHistoryMonths
        if (months < 24) {
          this.workHistoryMonthsValid = false
          this.workHistoryError = 'You are required to provide at least 2 years of employment history.'
          if (this.isUser || this.isMember) return []
          return ['Error occurred']
        } else if (months > 1199) {
          this.workHistoryMonthsValid = false
          this.workHistoryError = 'The total amount of months employed at a specific employer cannot exceed 1199. The years and months fields are combined to calculate the total months of employment at a specific employer.'
          if (this.isUser || this.isMember) return []
          return ['Error occurred']
        }
        // if (this.workHistory && this.workHistory.length > 0) {
        //   for (var i = 0; i < this.workHistory.length; i++) {
        //     if (this.workHistory[i].employerOffice === this.currentCustomer.mobile) {
        //       this.workHistoryMonthsValid = false
        //       this.workHistoryError = 'Employer phone cannot be the same as mobile'
        //       if (this.isMember) return []
        //       return ['Error occurred']
        //     }
        //   }
        // }
      }
      this.workHistoryMonthsValid = true
      return []
    },
    validateSpouseWorkHistory () {
      if (this.selectedSpouseEmploymentStatus) {
        this.spouseWorkHistoryValidated = true
        if (this.selectedSpouseEmploymentStatus.id === 0 || this.selectedSpouseEmploymentStatus.id === 3) {
          const months = this.totalSpouseWorkHistoryMonths
          if (months < 24) {
            this.spouseWorkHistoryError = 'You are required to provide at least 2 years of employment history.'
            this.spouseWorkHistoryMonthsValid = false
            if (this.isUser || this.isMember) return []
            return ['Error occurred']
          } else if (months > 1199) {
            this.spouseWorkHistoryMonthsValid = false
            this.spouseWorkHistoryError = 'The total amount of months employed at a specific employer cannot exceed 1199. The years and months fields are combined to calculate the total months of employment at a specific employer.'
            if (this.isUser || this.isMember) return []
            return ['Error occurred']
          }
        }
        this.spouseWorkHistoryMonthsValid = true
        return []
      }
      return []
    },
    // validateHomePhone () {
    //   this.homePhoneValidated = true
    //   if (this.currentCustomer.home && this.currentCustomer.mobile) {
    //     if (this.currentCustomer.home === this.currentCustomer.mobile) {
    //       this.homePhoneValidated = false
    //       this.homePhoneError = 'Home phone cannot be the same as mobile.'
    //       if (this.isMember) return []
    //       return ['Error occurred']
    //     }
    //   }
    //   this.homePhoneValidated = true
    //   return []
    // },
    onAutoSelectPrimaryAddress (address) {
      const primary = this.addresses.find((x) => x.isPrimary && x.id !== address.id)
      if (!primary) {
        const newPrimary = this.addresses.find((x) => !x.isPrimary && x.id !== address.id)
        if (newPrimary) {
          newPrimary.isPrimary = true
        }
      }
    },
    onUnselectNonPrimary (address) {
      if (address.isPrimary) {
        this.addresses.forEach((x) => {
          if (x.id !== address.id) {
            x.isPrimary = false
          }
        })
      }
    },
    onAutoSelectSpousePrimaryAddress (address) {
      const primary = this.spouseAddresses.find((x) => x.isPrimary && x.id !== address.id)
      if (!primary) {
        const newPrimary = this.spouseAddresses.find((x) => !x.isPrimary && x.id !== address.id)
        if (newPrimary) {
          newPrimary.isPrimary = true
        }
      }
    },
    onUnselectSpouseNonPrimary (address) {
      if (address.isPrimary) {
        this.spouseAddresses.forEach((x) => {
          if (x.id !== address.id) {
            x.isPrimary = false
          }
        })
      }
    },
    saveAddress: function (customerModel) {
      this.addresses.forEach(function (item) {
        var address = {
          id: isNaN(item.id) ? 0 : item.id,
          address1: item.address1,
          address2: item.address2,
          address3: item.address3,
          address4: item.address4,
          city: this.$lodash.startCase(item.city),
          country: item.country,
          postalCode: item.postalCode,
          state: item.state,
          gpsAddress: item.gpsAddress,
          ownershipType: item.ownershipType ? item.ownershipType.name : '',
          years: item.years === null || item.years === undefined || item.years === '' ? 0 : +item.years,
          months: item.months === null || item.months === undefined || item.months === '' ? 0 : +item.months,
          rate: item.rate,
          isPrimary: item.isPrimary
        }

        customerModel.addresses.push(address)
      }, this)
    },
    saveSpouseAddress: function (spouseModel) {
      this.spouseAddresses.forEach(function (item) {
        var address = {
          id: isNaN(item.id) ? 0 : item.id,
          address1: item.address1,
          address2: item.address2,
          address3: item.address3,
          address4: item.address4,
          city: this.$lodash.startCase(item.city),
          country: item.country,
          postalCode: item.postalCode,
          state: item.state,
          gpsAddress: item.gpsAddress,
          ownershipType: item.ownershipType ? item.ownershipType.name : '',
          years: item.years === null || item.years === undefined || item.years === '' ? 0 : +item.years,
          months: item.months === null || item.months === undefined || item.months === '' ? 0 : +item.months,
          rate: item.rate,
          isPrimary: item.isPrimary
        }

        spouseModel.addresses.push(address)
      }, this)
    },
    saveWorkHistory: function (customerModel) {
      this.workHistory.forEach(function (item) {
        var history = {
          id: isNaN(item.id) ? 0 : item.id,
          employer: item.employer,
          jobTitle: item.jobTitle,
          employerOffice: item.employerOffice,
          address1: item.address1,
          address2: item.address2,
          address3: item.address3,
          address4: item.address4,
          city: this.$lodash.startCase(item.city),
          country: item.country,
          postalCode: item.postalCode,
          state: item.state,
          gpsAddress: item.gpsAddress,
          years: item.years === null || item.years === undefined || item.years === '' ? 0 : +item.years,
          months: item.months === null || item.months === undefined || item.months === '' ? 0 : +item.months,
          grossIncome: item.grossIncome,
          otherIncome: item.otherIncome,
          otherIncomeSource: item.otherIncomeSource
        }

        customerModel.workHistory.push(history)
      }, this)
    },
    saveSpouseWorkHistory: function (spouseModel) {
      this.spouseWorkHistory.forEach(function (item) {
        var history = {
          id: isNaN(item.id) ? 0 : item.id,
          employer: item.employer,
          jobTitle: item.jobTitle,
          employerOffice: item.employerOffice,
          address1: item.address1,
          address2: item.address2,
          address3: item.address3,
          address4: item.address4,
          city: this.$lodash.startCase(item.city),
          country: item.country,
          postalCode: item.postalCode,
          state: item.state,
          gpsAddress: item.gpsAddress,
          years: item.years === null || item.years === undefined || item.years === '' ? 0 : +item.years,
          months: item.months === null || item.months === undefined || item.months === '' ? 0 : +item.months,
          grossIncome: item.grossIncome,
          otherIncome: item.otherIncome,
          otherIncomeSource: item.otherIncomeSource
        }
        spouseModel.workHistory.push(history)
      }, this)
    },
    addAddress: function (configuration) {
      const isSpouseAddress = configuration ? configuration.spouseAddress : false
      if (isSpouseAddress) {
        var spouseConfig = {
          sectionId: this.spouseAddresses.length + 100,
          loadCustomerOnly: configuration ? configuration.loadCustomerOnly : false,
          spouseAddress: true
        }
        var spouseAddress = this.createGenericAddress()
        spouseAddress.config = spouseConfig
        this.spouseAddresses.push(spouseAddress)
        if (this.spouseAddresses.length === 1) {
          this.spouseAddresses[0].isPrimary = true
        }
      } else {
        var config = {
          sectionId: this.addresses.length + 100,
          loadCustomerOnly: configuration ? configuration.loadCustomerOnly : false
        }
        var address = this.createGenericAddress()
        address.config = config
        this.addresses.push(address)
        if (this.addresses.length === 1) {
          this.addresses[0].isPrimary = true
        }
      }
    },
    addWorkHistory: function (configuration) {
      const isSpouseWorkHistory = configuration ? configuration.spouseWorkHistory : false
      if (isSpouseWorkHistory) {
        var spouseConfig = {
          sectionId: this.spouseWorkHistory.length + 100,
          loadCustomerOnly: configuration ? configuration.loadCustomerOnly : false
        }

        var spouseHistory = this.createGenericWorkHistory()
        spouseHistory.config = spouseConfig
        this.spouseWorkHistory.push(spouseHistory)
      } else {
        var config = {
          sectionId: this.workHistory.length + 100,
          loadCustomerOnly: configuration ? configuration.loadCustomerOnly : false
        }

        var history = this.createGenericWorkHistory()
        history.config = config
        this.workHistory.push(history)
      }
    },
    removeAddress (addressToRemove) {
      const isSpouseAddress = addressToRemove && addressToRemove.config ? addressToRemove.config.spouseAddress : false
      if (isSpouseAddress) {
        const indexToDelete = this.spouseAddresses.findIndex((x) => x.id === addressToRemove.id)
        this.spouseAddresses.splice(indexToDelete, 1)
        const primary = this.spouseAddresses.find((x) => x.isPrimary && x.id !== addressToRemove.id)
        if (!primary) {
          const newPrimary = this.spouseAddresses.find((x) => !x.isPrimary && x.id !== addressToRemove.id)
          if (newPrimary) {
            newPrimary.isPrimary = true
          }
        }
      } else {
        const indexToDelete = this.addresses.findIndex((x) => x.id === addressToRemove.id)
        this.addresses.splice(indexToDelete, 1)
        const primary = this.addresses.find((x) => x.isPrimary && x.id !== addressToRemove.id)
        if (!primary) {
          const newPrimary = this.addresses.find((x) => !x.isPrimary && x.id !== addressToRemove.id)
          if (newPrimary) {
            newPrimary.isPrimary = true
          }
        }
      }
    },
    removeWorkHistory: function (configuration) {
      var sectionId
      var offset = 100
      const isSpouseWorkHistory = configuration ? configuration.spouseWorkHistory : false
      if (isSpouseWorkHistory) {
        sectionId = this.spouseWorkHistory.length + offset - 1
        var spouseWorkHistoryFiltered = this.spouseWorkHistory.filter(function (el) {
          return el.config.sectionId !== sectionId
        })
        this.spouseWorkHistory = spouseWorkHistoryFiltered
      } else {
        sectionId = this.workHistory.length + offset - 1
        var workHistoryFiltered = this.workHistory.filter(function (el) {
          return el.config.sectionId !== sectionId
        })
        this.workHistory = workHistoryFiltered
      }
    },
    createGenericAddress (configuration) {
      return {
        id: this.$uuid.v4(),
        key: this.$uuid.v4(),
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        city: '',
        country: '',
        postalCode: '',
        state: '',
        gpsAddress: '',
        ownershipType: null,
        isPrimary: false,
        years: 0,
        months: 0,
        rate: null
      }
    },
    createGenericWorkHistory (configuration) {
      return {
        id: this.$uuid.v4(),
        employer: '',
        jobTitle: '',
        employerOffice: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        city: '',
        country: '',
        postalCode: '',
        state: '',
        gpsAddress: '',
        years: 0,
        months: 0,
        grossIncome: null,
        otherIncome: 0,
        otherIncomeSource: '',
        employmentStatusType: 0,
        otherIncomeSourceType: 0
      }
    },
    buildInitials: function () {
      const firstName = this.currentCustomer ? this.currentCustomer.firstName : this.firstName
      const middleName = this.currentCustomer ? this.currentCustomer.middleName : this.middleName
      const lastName = this.currentCustomer ? this.currentCustomer.lastName : this.lastName
      var derivedInitials = (firstName ? firstName[0] : '') + (middleName ? middleName[0] : '') + (lastName ? lastName[0] : '')
      if (this.currentCustomer) {
        this.currentCustomer.initials = derivedInitials
      } else {
        this.initials = derivedInitials
      }
    }
  },
  watch: {
    firstName: function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.firstName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    middleName: function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.middleName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    lastName: function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.lastName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    'currentCustomer.firstName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.firstName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    'currentCustomer.middleName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.middleName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    'currentCustomer.lastName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.lastName = titleCaseVersion
      } else {
        this.buildInitials()
      }
    },
    'currentCustomer.spouse.firstName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.spouse.firstName = titleCaseVersion
      }
    },
    'currentCustomer.spouse.lastName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.spouse.lastName = titleCaseVersion
      }
    },
    'currentCustomer.coApplicant.firstName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.coApplicant.firstName = titleCaseVersion
      }
    },
    'currentCustomer.coApplicant.lastName': function (newValue, oldValue) {
      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.currentCustomer.coApplicant.lastName = titleCaseVersion
      }
    },
    selectedRelationshipStatus: function (newValue, oldValue) {
      if (newValue && newValue.id === 0) {
        this.coApplicant = {
          id: 0,
          dealerId: 0,
          type: 'Individual',
          status: 'Active',
          firstName: null,
          lastName: null,
          email: null,
          mobile: null,
          home: null
        }

        this.currentCustomer.coApplicant = this.coApplicant
        this.selectedCoCustomer = null
        this.selectedMaritalStatus = this.definedTypes.customerMaritalStatus.options.find((x) => x.id === 1)
      }
      if (newValue && newValue.id === 5) {
        this.coApplicant = {
          id: 0,
          dealerId: 0,
          type: 'Individual',
          status: 'Active',
          firstName: null,
          lastName: null,
          email: null,
          mobile: null,
          home: null
        }

        this.currentCustomer.coApplicant = this.coApplicant
        this.selectedCoCustomer = null
      }
    },
    selectedCoCustomer: function (newValue, oldValue) {
      if (newValue) {
        this.currentCustomer.coApplicant.id = newValue.id
        this.currentCustomer.coApplicant.firstName = newValue.firstName
        this.currentCustomer.coApplicant.lastName = newValue.lastName
        this.currentCustomer.coApplicant.email = newValue.email
        this.currentCustomer.coApplicant.home = newValue.home
        this.currentCustomer.coApplicant.mobile = newValue.mobile
      }
    }
  },
  mounted () {
  }
}

export default mixin
